import { DOCUMENT } from '@angular/common';
import { Component, Inject, Injector } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Lightbox, LightboxEvent, LightboxConfig } from 'angular2-lightbox';
import { AgencyService, PropertyService } from '../common-theme/api';
import { HouseDetailsBaseComponent } from './../common-theme/index';

@Component({
  selector: 'app-house-details',
  templateUrl: './house-details.component.html',
  styleUrls: ['./house-details.component.scss']
})

export class HouseDetailsComponent extends HouseDetailsBaseComponent {
}



// WEBPACK FOOTER //
// ./src/app/houses/house-details.component.ts